import React from 'react';
import Scatter from '../Scatter/Scatter';

const VisPuntenWolk = (props) => {

	const domain = { minX: 10000, maxX: 130000, minY: -5, maxY: 5 };
	const margin = {top: 90, right: 60, bottom: 90, left: 30}

	const { data, sliding, highlights } = props;

	const highlight = highlights.filter(item => item.indexOf('scatter') > -1)[0];

	const formatX = value => value/1000;


	return (
		<Scatter
			title={"Koopkrachtontwikkeling"}
			background="none"
			colorPoints="#e5b2cf"
			colorAxis="#fff"
			source="Fictieve cijfers"
			labelY="%"
			labelX="euro"
			unitX="x 1000"
			margin={margin}
			domain={domain}
			data={data.scatter}
			formatX={formatX}
			sliding={sliding}
			highlight={highlight}
		/>
	)
}

export default VisPuntenWolk;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisPuntenWolk.js